var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_2_80",
    "data-name": "Component 2 \\u2013 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 28.8,
    viewBox: "0 0 30 28.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    fill: "#fff",
    stroke: "#e0e7ff",
    strokeWidth: 1,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 28.8,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 27.8,
    rx: 3.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "edit-line",
    transform: "translate(7.406 6.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22972",
    "data-name": "Path 22972",
    d: "M0,0H15.187V15.187H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22973",
    "data-name": "Path 22973",
    d: "M5.16,10.87l6.418-6.418-.895-.895L4.266,9.975v.895Zm.525,1.266H3V9.451l7.236-7.236a.633.633,0,0,1,.895,0L12.921,4a.633.633,0,0,1,0,.895ZM3,13.4H14.391v1.266H3Z",
    transform: "translate(-1.102 -0.745)",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.f3669c8a0bf119ce0acc1dfe30a5553a.svg";
export { ForwardRef as ReactComponent };